import { render, staticRenderFns } from "./FlexSubscriptions.vue?vue&type=template&id=1d7c70ac&scoped=true&"
import script from "./FlexSubscriptions.vue?vue&type=script&lang=js&"
export * from "./FlexSubscriptions.vue?vue&type=script&lang=js&"
import style0 from "./FlexSubscriptions.vue?vue&type=style&index=0&id=1d7c70ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7c70ac",
  null
  
)

export default component.exports